import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  saf: '',
  isLoadingSaf: false,
  errorSaf: null,
  
  postsaf: '',
  isErrorPostsaf: false,
  isLoadingPostsaf: false,

  consignee: '',
  errorConsignee: false,
  isLoadingConsignee: false,

  shipper: '',
  errorShipper: false,
  isLoadingShipper: false,

  postconsignee: '',
  isErrorPostconsignee: false,
  isLoadingPostconsignee: false,

  editconsignee: '',
  isErrorEditconsignee: false,
  isLoadingEditconsignee: false,

  deleteconsignee: '',
  isErrorDeleteconsignee: false,
  isLoadingDeleteconsignee: false,

  postsubmit: '',
  isErrorPostSubmit: false,
  isLoadingPostSubmit: false,

  bank: '',
  errorBank: false,
  isLoadingBank: false,

  docSaf: '',
  errorDocSaf: false,
  isLoadingDocSaf: false,

  uploaddocSaf: '',
  errorUploadDocSaf: false,
  isLoadingUploadDocSaf: false,

  docSafApproved: '',
  errorDocSafApproved: false,
  isLoadingDocSafApproved: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/saf/index.js